"use strict";
import axios from "../../../axios";
import deepSeal from "../../../lib/deep_seal";
class Params {
    constructor() {
        Object.assign(this, { "mail": { "to": null, "cc": null, "bcc": null, "subject": null, "body": null, "account": null } });
        deepSeal(this);
    }
}
class BuildableParams {
    constructor() {
        Object.assign(this, { "mail": { "to": [], "cc": [], "bcc": [], "subject": null, "body": null, "account": null } });
    }
    build(key) { return {}[key]; }
}
export default {
    Params: Params,
    BuildableParams: BuildableParams,
    execute: function (params) {
        return axios.patch("/jtj/commands/hf_member__get_gmail_url", { params });
    }
};
